import { Reveal, Eyebrow } from "./Reveal";

const steps = [
  { n: "01", t: "Talk", d: "We chat about your business, your goals and the look you want." },
  { n: "02", t: "Design", d: "I create a clean, modern design tailored to your brand." },
  { n: "03", t: "Build", d: "Your site is hand-built, tested on every screen size." },
  { n: "04", t: "Launch", d: "Your site goes live — and I can keep it running for you after." },
];

export const Process = () => (
  <section id="process" className="border-y border-white/5 bg-[#0A1128]/60 py-28 sm:py-40">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>02 — How it works</Eyebrow>
        <h2 className="max-w-2xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-6xl">
          Simple from start to finish.
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="h-full">
            <div data-testid={`process-step-${s.n}`} className="group h-full bg-[#030712] p-8 transition-colors duration-500 hover:bg-[#0A1128]">
              <span className="font-mono text-sm text-sky-300">{s.n}</span>
              <h3 className="mt-16 font-display text-3xl font-medium tracking-tight text-white transition-transform duration-500 group-hover:translate-x-2">{s.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
